var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ success: _vm.success },attrs:{"name":_vm.name},on:{"mousedown":function($event){$event.preventDefault();}}},[(!_vm.success)?_vm._t("default"):_vm._e(),(_vm.success)?_c('svgicon',{attrs:{"name":"check-arrow"}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }